import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useTheme as useAppTheme } from '@material-ui/core/styles'
import { createTheme, ThemeProvider } from '@mui/material/styles'

// The app's theme lives in @material-ui/core; components imported from
// @mui/material read their own theme context and otherwise fall back to the
// stock light theme, so in dark mode their chips kept light-mode text on a dark
// page. This hands them the app's palette, type and shape (light or dark).
// Scoped to the somatic screens built on @mui/material; germline screens are
// left exactly as they render today.
const MuiV5Bridge = ({ children }) => {
  const app = useAppTheme()
  const theme = useMemo(
    () =>
      createTheme({
        palette: app.palette,
        typography: app.typography,
        shape: app.shape,
        breakpoints: app.breakpoints,
        direction: app.direction,
      }),
    [app],
  )
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

MuiV5Bridge.propTypes = { children: PropTypes.node }
MuiV5Bridge.defaultProps = { children: null }

export default MuiV5Bridge
